module.exports = __webpack_public_path__ + "54cf98f5/img/product-icon-grey.b248963c.svg";